<template>
  <div>
    <h3 class="h-title">服务要素信息</h3>
    <el-form class="e-form f-b" ref="cForm2" :model="cForm2" label-width="160px"  label-position="left" :rules="cRules">
      <el-form-item label="选择律所" prop="lawFirmObj">
        <el-select v-model="cForm2.lawFirmObj" @change="setLawFirm" value-key="nodeId" placeholder="请选择律所" style="width: 100%">
          <el-option
            v-for="dict in lawOptions"
            :key="dict.nodeId"
            :label="dict.nodeName"
            :value="dict"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择权威节点" prop="authorityNodeArr">
        <el-select v-model="cForm2.authorityNodeArr" 
        @remove-tag="changeNode" 
        @change="seteNode" multiple         
        filterable 
        @input.native="filterData"
        @clear="clearData"
        value-key="nodeName" placeholder="请选择权威节点" style="width: 100%">
          <el-option
            v-for="item in nodeOptions"
            :key="item.id"
            :label="item.nodeName"
            :disabled="item.isRequire == '0'"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="存储类型" prop="saveType">
        <el-select v-model="cForm2.saveType" placeholder="请选择存储类型" style="width: 100%">
          <el-option
            v-for="dict in typeOptions"
            :key="dict.dictValue"
            :label="dict.dictLabel"
            :value="dict.dictValue"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="主合同名称" prop="mainContractName">
        <el-input v-model="cForm2.mainContractName" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item label="主合同编号" prop="mainContractNo">
        <el-input v-model="cForm2.mainContractNo" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item label="主合同期限" prop="mainContractPeriod">
          <el-date-picker  style="width: 100%"
              format="yyyy-MM-dd" 
              value-format="yyyy-MM-dd"
              placeholder="请选择"
              v-model="cForm2.mainContractPeriod"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
          </el-date-picker>
      </el-form-item>
      <el-form-item class="w-70" label="主合同金额(万元)" prop="mainContractAmount" >
        <el-input-number v-model="cForm2.mainContractAmount" controls-position="right" @blur="conversion('mainContractAmount')" :precision="4" :step="0.1" :min="cForm2.consensusAmount||0" placeholder="请输入数字，小数点后4位" style="width: 100%"></el-input-number>
      </el-form-item> 
      <el-form-item class="w-70" label="共识金额(万元)" prop="consensusAmount">
        <el-input-number v-model="cForm2.consensusAmount" controls-position="right" @blur="conversion('consensusAmount')" :precision="4" :step="0.1" :min="0" :max="cForm2.mainContractAmount||Infinity" placeholder="请输入数字，小数点后4位" style="width: 100%"></el-input-number>
      </el-form-item> 
      <el-form-item label="主合同签约主体1名称" prop="mainContractSignName1">
        <el-input v-model="cForm2.mainContractSignName1"  :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <el-form-item label="主合同签约主体2名称" prop="mainContractSignName2">
        <el-input v-model="cForm2.mainContractSignName2" :maxlength="50" placeholder="请输入<=50文字" />
      </el-form-item>
      <div v-for="index in mainContractSignNum" :key="index">
        <el-form-item :label="`主合同签约主体${index+2}名称`" :prop="`mainContractSignName${index+2}`" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm2['mainContractSignName'+(index+2)]" :maxlength="50" placeholder="请输入<=50文字" style="width: 80%" />
          <el-button class="s-but" type="orange" @click="delMainNum(index)" style="width: 15%; margin: 0 0 0 5%">删除</el-button>
        </el-form-item>
      </div>
      
      <el-button v-show="mainContractSignNum<8" class="s-but" style="margin-top:5px" icon="el-icon-plus" type="orange" @click="addMainNum">其他签约主体</el-button>

      <!-- 从合同 -->
      <div v-if="cForm2.mainContractAmount > cForm2.consensusAmount">
        <el-form-item label="从合同名称" prop="subContractName" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm2.subContractName" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <el-form-item label="从合同编号" prop="subContractNo" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm2.subContractNo" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <el-form-item label="从合同期限" prop="subContractPeriod" :rules="[{required: true,message:'请选择',trigger:'change'}]">
            <el-date-picker  style="width: 100%"
                format="yyyy-MM-dd" 
                value-format="yyyy-MM-dd"
                placeholder="请选择"
                v-model="cForm2.subContractPeriod"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
        </el-form-item>
        <el-form-item class="w-70" label="从合同金额(万元)" prop="subContractAmount" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input-number v-model="cForm2.subContractAmount" controls-position="right" @blur="conversion('subContractAmount')" :precision="4" :step="0.1" :min="0" placeholder="请输入数字，小数点后4位" style="width: 100%"></el-input-number>
        </el-form-item> 
        <el-form-item label="从合同签约主体1名称" prop="subContractSignName1" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm2.subContractSignName1" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <el-form-item label="从合同签约主体2名称" prop="subContractSignName2" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
          <el-input v-model="cForm2.subContractSignName2" :maxlength="50" placeholder="请输入<=50文字"/>
        </el-form-item>
        <div v-for="i in subContractSignNum" :key="'s'+i">
          <el-form-item :label="`从合同签约主体${i+2}名称`" :prop="`subContractSignName${i+2}`" :rules="[{required: true,message:'请输入',trigger:'blur'}]">
            <el-input v-model="cForm2['subContractSignName'+(i+2)]" :maxlength="50" placeholder="请输入<=50文字" style="width: 80%" />
            <el-button class="s-but" type="orange" @click="delSubNum(i)" style="width: 15%; margin: 0 0 0 5%">删除</el-button>
          </el-form-item>
        </div>

        <el-button v-show="subContractSignNum<8" class="s-but" style="margin-top:5px" icon="el-icon-plus" type="orange" @click="addSubNum">其他签约主体</el-button>
      </div>
    </el-form>
    <div class="cenrer">			
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('1')" :loading="butLoading">下一步</el-button>
    </div>
  </div>
</template>

<script>
import { elFormErrorScrollIntoView } from '@/utils/util'
export default {
  name: "step2",
  props: ["active"],
  data() {
    return {
      headers: {},
      action: '',
      file: '',
      butLoading: false,
      cFileList: [],
      cForm2: {},
      // 表单校验
      cRules: {
        lawFirmObj: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        authorityNodeArr: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        saveType: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        mainContractName: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractNo: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractPeriod: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        mainContractAmount: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        consensusAmount: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractSignName1: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        mainContractSignName2: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
      },
      lawOptions: [],
      nodeOptions: [],
      nodeTotal: 0,
      typeOptions: [],
      lawFirmOptions: [],
      mainContractSignNum: 0,
      subContractSignNum: 0,
      mainContractSignList: [],
      subContractSignList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 1000,
        businessType:'1', 
        status: '0'
      },
    }
  },
  watch: {
    active(newVal) {
        if(newVal == 2) {
          window.scrollTo(0,0);
          this.cForm2 = JSON.parse(sessionStorage.setpForm);
          this.getLawFirm()
          this.getNodeList()
          if(this.cForm2.mainContractPeriodStart){
            this.$set(this.cForm2, 'mainContractPeriod', [this.cForm2.mainContractPeriodStart, this.cForm2.mainContractPeriodEnd])       
          }
          if(this.cForm2.subContractPeriodStart){
            this.$set(this.cForm2, 'subContractPeriod', [this.cForm2.subContractPeriodStart, this.cForm2.subContractPeriodEnd])       
          }

          // 金额
          if(this.cForm2.mainContractAmount == null){
            delete this.cForm2.mainContractAmount
          }
          if(this.cForm2.consensusAmount == null){
            delete this.cForm2.consensusAmount
          }
          if(this.cForm2.subContractAmount == null){
            delete this.cForm2.subContractAmount
          }

          // 主体个数
          for(let j=10; j>2; j--){
            if(this.cForm2['mainContractSignName'+(j)]){
              this.mainContractSignNum = j-2;
              return
            }
          }
          // 从合同主体个数
          for(let j=10; j>2; j--){
            if(this.cForm2['subContractSignName'+(j)]){
              this.subContractSignNum = j-2;
              return
            }
          }
        } 
      }
    },
  methods: { 
    // 查询权威节点
    filterData(e){
      this.queryParams.pageNum = 1
      this.queryParams.nodeName = e.target.value;
      this.selectNode();
    },
    // 清空权威节点
    clearData() {
      this.queryParams.nodeName = ""
      this.queryParams.pageNum = 1
      this.selectNode();
    },
    selectNode(){
      this.$api.api.nodeList({...this.queryParams, nodeType: '1'}).then(response => {
        if(response.code == 200){
          this.nodeOptions = response.rows
        }else {
          this.$message.error(response.msg);
        } 
      })
    },
    conversion(name) {
      this.cForm2[name+'Rmb'] = this.smalltoBIG(this.cForm2[name]*10000);
    },
    /** 数字金额大写转换(可以处理整数,小数,负数) */    
    smalltoBIG(n){    
      let fraction = ['角', '分'];    
      let digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];    
      let unit = [ ['元', '万', '亿'], ['', '拾', '佰', '仟']  ];    
      let head = n < 0? '欠': '';    
      n = Math.abs(n);    
    
      let s = '';    
    
      for (let i = 0; i < fraction.length; i++)     
      {    
          s += (digit[Math.floor(n * 10 * Math.pow(10, i)) % 10] + fraction[i]).replace(/零./, '');    
      }    
      s = s || '整';    
      n = Math.floor(n);    
    
      for (let i = 0; i < unit[0].length && n > 0; i++)     
      {    
          let p = '';    
          for (let j = 0; j < unit[1].length && n > 0; j++)     
          {    
              p = digit[n % 10] + unit[1][j] + p;    
              n = Math.floor(n / 10);    
          }    
          s = p.replace(/(零.)*零$/, '').replace(/^$/, '零')  + unit[0][i] + s;    
      }    
      return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');    
    },
    addMainNum(){
      this.mainContractSignNum++
    },
    delMainNum(i){
      let mainArry = []
      for(let j=0; j<this.mainContractSignNum; j++ ){
        mainArry[j] = this.cForm2['mainContractSignName'+(j+3)]
      }
      this.mainContractSignNum--
      mainArry.splice(i-1, 1)

      for(let m=0; m<this.mainContractSignNum; m++ ){
        this.cForm2['mainContractSignName'+(m+3)] = mainArry[m]
      }
      this.cForm2['mainContractSignName'+(this.mainContractSignNum+3)] = ""
    },
    addSubNum(){
      this.subContractSignNum++
    },
    delSubNum(i){
      let subArry = []
      for(let j=0; j<this.subContractSignNum; j++ ){
        subArry[j] = this.cForm2['subContractSignName'+(j+3)]
      }
      this.subContractSignNum--
      subArry.splice(i-1, 1)

      for(let m=0; m<this.subContractSignNum; m++ ){
        this.cForm2['subContractSignName'+(m+3)] = subArry[m]
      }
      
      this.cForm2['subContractSignName'+(this.subContractSignNum+3)] = ""
    },    
    changeNode(item){
      if(item.isRequire == '0'){
        this.$message.error("此项为必须项，不能删除！");
        this.cForm2.authorityNodeArr.push(item)
      }
    },
    seteNode(obj){
      this.clearData()
      obj.forEach((item, i) => {
        if(item.nodeName == this.cForm2.lawFirmName){
          this.$message.error("律所与权威节点不能选择相同机构！");
          this.cForm2.authorityNodeArr.splice(i, 1)
        }
      })
    },
    setLawFirm(obj){
      // 律所与权威节点不能相同
      let index = this.cForm2.authorityNodeArr.findIndex((item) => item.nodeName === obj.deptName); 
      if(index >= 0){
        this.$message.error("律所与权威节点不能选择相同机构！");
        delete this.cForm2['lawFirmObj']
      }else {
        this.cForm2.lawFirmName = obj.nodeName
        this.cForm2.lawFirm = obj.nodeId
      }      
    },
    getLawFirm(){
      this.$api.api.getDicts("save_type").then(response => {
          this.typeOptions = response.data;
      });
      this.queryParams.nodeName = ''
      this.$api.api.nodeList({...this.queryParams,nodeType:'2'}).then(response => {
          if(response.code == 200){
            this.lawOptions = response.rows 
            if(this.cForm2.lawFirmName){
              this.$set(this.cForm2, 'lawFirmObj', {
                nodeName: this.cForm2.lawFirmName,
                nodeId: this.cForm2.lawFirm
              })
            }
          }else {
            this.$message.error(response.msg);
          }      
        });
    },
    uniqueFun(arr,type){
      const res = new Map();
      return arr.filter((a)=>!res.has(a[type])&& res.set(a[type],1));
    },
    getNodeList(){
      this.$api.api.nodeList({...this.queryParams, nodeType: '1'}).then(response => {
        if(response.code == 200){
          this.nodeOptions = response.rows
          this.nodeTotal = response.total
          let authorityArr = []    
          this.nodeOptions.forEach(item => {
            if(item.isRequire == '0'){
              authorityArr.push({
                id: item.id,
                nodeName: item.nodeName
              })
            }
          })  
          if(this.cForm2.authorityNode){            
            let nodeArr = JSON.parse(this.cForm2.authorityNode)
            nodeArr.forEach(item =>{
              if(this.nodeOptions.findIndex((v) => {return v.id == item.id;}) >= 0){
                authorityArr.push({
                  id: item.id,
                  nodeName: item.name
                })
              }             
            })
          }    
          this.$set(this.cForm2, 'authorityNodeArr', this.uniqueFun(authorityArr, 'id')) 
        }else {
          this.$message.error(response.msg);
        }      
      });
    },
    prev() {
      sessionStorage.setpForm = JSON.stringify(this.cForm2);
      this.$emit('prev')
    },
    cSubmitForm(type){
      if(this.cForm2.mainContractPeriod){
        this.cForm2.mainContractPeriodStart = this.cForm2.mainContractPeriod[0]
        this.cForm2.mainContractPeriodEnd = this.cForm2.mainContractPeriod[1]
      }
      if(this.cForm2.subContractPeriod){
        this.cForm2.subContractPeriodStart = this.cForm2.subContractPeriod[0]
        this.cForm2.subContractPeriodEnd = this.cForm2.subContractPeriod[1]
      } 
      if(type == '0'){                  
        this.butLoading = true;
        this.cForm2.status = '0'
        this.cForm2.authorityNode = []
        this.cForm2.authorityNodeArr.forEach(item => {
          this.cForm2.authorityNode.push({
            id: item.id,
            name: item.nodeName
          })
        })
        this.cForm2.authorityNode = JSON.stringify(this.cForm2.authorityNode)
        this.$api.api.saveContract(JSON.stringify(this.cForm2)).then(response => {
          this.butLoading = false;
          if(response.code == 200){
            sessionStorage.removeItem("setpForm")
            this.$message.success("保存成功");
            this.$router.go(-1);
          }     
        });
        
      }else{
        this.$refs["cForm2"].validate(valid => {
          if (valid) {
            if(this.nodeTotal >= 4){
              if(this.cForm2.authorityNodeArr.length !== 4){
                this.$message.error("权威节点请选择4个！");
                return false
              }
            }else {
              if(this.cForm2.authorityNodeArr.length !== this.nodeTotal){
                this.$message.error("权威节点请选择"+this.nodeTotal+"个！");
                return false
              }
            }
            this.cForm2.authorityNode = []
            this.cForm2.authorityNodeArr.forEach(item => {
              this.cForm2.authorityNode.push({
                id: item.id,
                name: item.nodeName
              })
            })
            this.cForm2.authorityNode = JSON.stringify(this.cForm2.authorityNode)
            sessionStorage.setpForm = JSON.stringify(this.cForm2);
            this.$emit('next');
          }else {
            this.$nextTick(() => {
              elFormErrorScrollIntoView()
            })
          }
        }) 
      }  
    },
    handleError(err, file, fileList){
      this.$message.error(file.name + "文件上传失败");
    },
    beforeUpload(file) { 	
      const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
      
      if(!isLt2M) {
        this.$message.error('上传文件大小不能超过 80MB！');
      }
      return isLt2M
    },
    cUpload(response, file, list){
        if(response.code == 200){
          this.cForm2.fileName = file.name
          this.cForm2.fileHash = response.data.hash
          this.$set(this.cForm2, 'fileUrl', response.data.path)
        }else{
            this.$message.error(file.name + "文件上传失败");
            this.cForm2.fileName = ''
            this.cForm2.fileHash = ''
            this.cForm2.fileUrl = ''
            this.cFileList = []
        }              
    },
    handleCRemove(file, fileList) {
      this.cForm2.fileName = ''
      this.cForm2.fileHash = ''
      this.cForm2.fileUrl = ''
      this.cFileList = []
    },
  }
}
</script>
